import React, { useState, useEffect, useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import "react-calendar/dist/Calendar.css";
import Moment from "moment";
import { updateRemoveUserRequest } from "../Services/ReportingService";
import "../style/DetailsModals.css";
import { NotificationsContext } from "../Contexts/NotificationsContext";

const RemoveRequestDetailsModal = (props) => {
  const [request, setRequest] = useState();
  const [wasRequestUpdated, setWasRequestUpdated] = useState(false);
  const { addNotification } = useContext(NotificationsContext);

  useEffect(() => {
    if (props.show) {
      setRequest(props.request);
    }
  }, [props.request, props.show]);

  const onCheckboxClick = (checkboxClicked) => {
    if (checkboxClicked === "inTwo") {
      setRequest({ ...request, IsInTwoAccountDisabled: !request.IsInTwoAccountDisabled });
    }
    if (checkboxClicked === "crm") {
      setRequest({ ...request, IsCrmAccountDisabled: !request.IsCrmAccountDisabled });
    }
    if (checkboxClicked === "email") {
      setRequest({ ...request, IsEmailAccountModified: !request.IsEmailAccountModified });
    }
    setWasRequestUpdated(true);
  };

  const onSave = () => {
    if (wasRequestUpdated) {
      props.setRequestIdBeingUpdated(request.RequestId);
      updateRemoveUserRequest(request)
        .then(() => {
          props.setUpdatedRequest({
            request: request,
            type: "remove",
          });
          addNotification({ show: true, type: "Success", description: "User Remove Request Updated Successfully" });
          props.onHide();
        })
        .catch(() => {
          addNotification({
            show: true,
            type: "Error",
            description: (
              <>
                Updating Remove User Request Failed. We ran into an issue submitting your request. Please contact
                <b> itsupport@gocitywide.com</b> for assistance.
              </>
            ),
          });
          props.setRequestIdBeingUpdated("");
          props.onHide();
        });
    }
    props.onHide();
  };

  return (
    <Modal show={props.show} onHide={props.onHide} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        {props.request && (
          <Modal.Title id="contained-modal-title-vcenter">
            Remove User Request - {props.request.UserFullName}
          </Modal.Title>
        )}
      </Modal.Header>
      <Modal.Body>
        {props.request && (
          <div className="row justify-content-center">
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>User Full Name</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="removeUserRequestFullName"
                  value={props.request.UserFullName}
                  disabled={true}
                />
              </div>
              <div className="col-lg ">
                <strong>User Job Title</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="removeUserRequestJobTitle"
                  value={props.request.UserPosition}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg ">
                <strong>Requested Date</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="removeUserRequestRequestedDate"
                  value={Moment(props.request.CreatedDate).format("MMMM Do YYYY, h:mma")}
                  disabled={true}
                />
              </div>
              <div className="col-lg ">
                <strong>Requested By</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="removeUserRequestRequestedBy"
                  value={props.request.RequestedBy}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg ">
                <strong>Email Access Duration</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="removeUserRequestEmailAccessDuration"
                  value={props.request.EmailAccessDuration}
                  disabled={true}
                />
              </div>
              <div className="col-lg ">
                <strong>Email Recipient</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="removeUserRequestEmailRecipient"
                  value={props.request.EmailRecipient}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg ">
                <strong>Requested Time Frame</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="removeUserRequestRequestedTimeFrame"
                  value={Moment(props.request.RequestedTimeFrame).format("MMMM Do YYYY, h:mma")}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg ">
                <strong>Notify Franchisee</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="removeUserRequestNotifyFranchisee"
                  value={props.request.NotifyFranchisee}
                  disabled={true}
                />
              </div>
              <div className="col-lg ">
                <strong>Notify Other</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="removeUserRequestNotifyOther"
                  value={props.request.NotifyOther}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg ">
                <strong>Is Unplanned?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="removeUserRequestIsUnplanned"
                  value={props.request.IsUnplanned}
                  disabled={true}
                />
              </div>
              <div className="col-lg ">
                <strong>Remove From CityWideYOU?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="removeUserRequestIsUnplanned"
                  value={props.request.CityWideYou}
                  disabled={true}
                />
              </div>
            </div>
            {props.mode === "completed" && (
              <div className="row my-1">
                <div className="col-lg ">
                  <strong>Completed By</strong>
                  <input
                    type="text"
                    className={`text-input w-100`}
                    name="removeUserRequestCompletedBy"
                    value={props.request.CompletedBy}
                    disabled={true}
                  />
                </div>
                <div className="col-md-4 ">
                  <strong>Completed Date</strong>
                  <input
                    type="text"
                    className={`text-input w-100`}
                    name="removeUserRequestCompletedDate"
                    value={Moment(props.request.CompletedDate).format("MMMM Do YYYY, h:mma")}
                    disabled={true}
                  />
                </div>
              </div>
            )}
            <div className="row justify-content-center my-1">
              <div className="col-md-4 ">
                <strong>How Did Employee Leave?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="removeUserRequestHowDidEmployeeLeave"
                  value={props.request.HowDidEmployeeLeave}
                  disabled={true}
                />
              </div>
              <div className="col-lg ">
                <strong>Why Did Employee Leave?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="removeUserRequestWhyDidEmployeeLeave"
                  value={props.request.WhyDidEmployeeLeave}
                  disabled={true}
                />
              </div>
            </div>
            <div className="mt-1">
              <div className="d-flex flex-row">
                <div className="col-lg checklist-item">
                  {props.mode === "incomplete" && request && (
                    <input
                      type="checkbox"
                      className={`details-modal-checkbox`}
                      name="removeUserRequestIsCrmAccountDisabled"
                      checked={request.IsCrmAccountDisabled}
                      onChange={() => onCheckboxClick("crm")}
                    />
                  )}
                  <strong>Is CRM Account Disabled?</strong>
                  {props.mode === "completed" && (
                    <strong className="ms-5">
                      <em>{props.request.IsCrmAccountDisabled ? "Yes" : "No"}</em>
                    </strong>
                  )}
                </div>
                <div className="col-lg checklist-item">
                  {props.mode === "incomplete" && request && (
                    <input
                      type="checkbox"
                      className={`details-modal-checkbox`}
                      name="removeUserRequestIsEmailAccountModified"
                      checked={request.IsEmailAccountModified}
                      onChange={() => onCheckboxClick("email")}
                    />
                  )}
                  <strong>Is Email Account Modified?</strong>
                  {props.mode === "completed" && (
                    <strong className="ms-5">
                      <em>{props.request.IsEmailAccountModified ? "Yes" : "No"}</em>
                    </strong>
                  )}
                </div>
              </div>
              <div className="checklist-item checklist-item-single">
                {props.mode === "incomplete" && request && (
                  <input
                    type="checkbox"
                    className={`details-modal-checkbox`}
                    name="removeUserRequestIsInTwoAccountDeleted"
                    checked={request.IsInTwoAccountDisabled}
                    onChange={() => onCheckboxClick("inTwo")}
                  />
                )}
                <strong>Is InTwo Account Deleted?</strong>
                {props.mode === "completed" && (
                  <strong className="ms-5">
                    <em>{props.request.IsInTwoAccountDisabled ? "Yes" : "No"}</em>
                  </strong>
                )}
              </div>
            </div>
            <div className="row justify-content-left my-1">
              <div className="col-md-3 text-left" style={{ width: "100%" }}>
                <strong>Special Instructions:</strong>
                <textarea
                  className="text-input"
                  rows={7}
                  style={{ width: "100%" }}
                  disabled
                  value={props.request.SpecialInstruction}
                ></textarea>
              </div>
            </div>
            {props.request.LastUpdatedBy && props.mode === "incomplete" && (
              <div className="row my-1">
                <div className="col-lg ">
                  <strong>Last Updated By</strong>
                  <input
                    type="text"
                    className={`text-input w-100`}
                    name="removeUserRequestLastUpdatedBy"
                    value={props.request.LastUpdatedBy.replace(/^"(.*)"$/, "$1")}
                    disabled={true}
                  />
                </div>
                <div className="col-md-4 ">
                  <strong>Last Updated</strong>
                  <input
                    type="text"
                    className={`text-input w-100`}
                    name="removeUserRequestLastUpdated"
                    value={Moment(props.request.LastUpdatedDate).format("MMMM Do YYYY, h:mma")}
                    disabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
      {props.mode === "incomplete" && (
        <Modal.Footer style={{ position: "sticky", bottom: 0, backgroundColor: "white" }}>
          <Button data-testid="delete-modal-no-button" variant="primary" onClick={() => onSave()}>
            Save
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default RemoveRequestDetailsModal;
